export class AdminData  {

    constructor(
        public id?: number,
        public user?: string,
        public role?: string,
        public name?: string,
        public lastname?: string,
        public created_at?: string,
        public updated_at?: string,
        public permission?: string[],
        public postCategories?: string[],
    ) {

    }

    public isLogged() {
        return !!this.id;
    }

    public setData(data: any) {
        this.id = data?.id;
        this.user = data?.user;
        this.role = data?.role;
        this.name = data?.name;
        this.lastname = data?.lastname;
        this.created_at = data?.created_at;
        this.updated_at = data?.updated_at;
        this.permission = data?.permission || [];
        this.postCategories = data?.postCategories || [];
    }

}